module.exports = __webpack_public_path__ + "img/affilieted-dist.a3ed2112.png";